<template>
    <b-embed
            type="iframe"
            aspect="16by9"
            :src="`//fast.wistia.com/embed/iframe/${ videoId }.jsonp`"
            allowfullscreen
            sandbox="allow-scripts"
            v-if="videoId !== ''"
    />
</template>

<script>
    export default {
        name: "WistiaVideo",
        props: {
            videoId: String
        }
    }
</script>